<style lang="scss" scoped>
	@import "./5_khsm.css";

	.red_colors {
		color: #ef4c3d !important;
	}
	.red_color1 {
		border:1px solid #ef4c3d !important;
	}

	.el-col-lg-14{
		width: 80%;
	}
	.directory{
        width: 210px;
        margin: auto;
    }
	.el-collapse{
		border: 0;
	}
	
	
</style>
<style>
	#o5_khsm .el-collapse-item__header{
		
		border: 0;
		background-color: #f0f7f0;
		/* margin-top: 20px; */
		padding: 0.6rem;
		height: auto;
		font-size: 0.75rem;
		line-height: 1.3rem;
	}
	#o5_khsm .el-collapse-item{
		box-shadow: 0 0 15px #cbc9c9;
	}
	#o5_khsm .el-collapse-item__wrap{
		background: #f0f7f0;
		border: 1px solid #EBEEF5;
		border-top: 0;
		padding: 5px 15px;
	}

	.red_border .el-input__inner{
		border-color: #ef4c3d !important;
	}
	.collapse_1 .el-collapse-item__header{
		height: auto;
		margin-top: 0;
		font-size: 0.75rem;
		line-height: 1.3rem;
	}
	.o1_eng .collapse_1 .el-collapse-item__header{
		line-height: 1.1rem;
	}
	.redClass{
		margin-top:20px;
	}
	.redClass .el-collapse-item__header{
		height: auto;
		margin-top: 0;
		font-size: 0.75rem;
		line-height: 1.3rem;
	}
	.o1_eng .redClass .el-collapse-item__header{

		line-height: 1.1rem;
	}
	@media screen and (min-width:2200px){
		#o5_khsm .collapse_1 .el-collapse-item__header{
			line-height:1rem
		}
	}
	
</style>

<template>
	<div id="o5_khsm" :class="{'o1_eng'  : ifEng}">
		<div style="width: 60%;margin:1rem  auto 0;padding-bottom: 4rem;">
			<div class="khtitleCla" style="background: #3d7077;">{{$t('login.khtitle')}} - <span style="color:#ffffff; ">{{$t('login.step')}} 5 / 7</span></div>
			<div style="display: flex;">
				 <div>
                    <tab-bar />
                    <directory></directory>
                </div>
				<el-form ref="khsm1Form" :rules="rules" :model="khsm1Form" label-position="top" :hide-required-asterisk="true">
					<div class="titleCal" style="background: #3d7077;">
						<img style="position: relative; top: 2px;" src="../../image/titleImg.png" alt="">
						<span style="color:#ffffff;margin-left: 10px;">{{ this.$t("khsm.khsm") }}</span>
					</div>
					<div class="ListView grxxBorder" style="background: #f0f7f0;">
						<el-collapse v-model="activeNames" accordion>
							<!-- 1 -->
							<el-collapse-item  name="1" :style="obj.question1 ? 'border:1px solid #ef4c3d':''" class="collapse_1">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question1'>1. </span>
									<span :class='obj.question1'>{{$t('khsm.wenti_1')}}</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question1" >
											<!-- <div slot='label'  v-if='obj.question1' class="red_color" style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" class="red_color">1.&nbsp;</span> 
												<span class="red_color">
													{{$t('khsm.wenti_1')}}
												</span>
											</div>
											<div slot='label' v-else style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;">1.</span> 
												<span>
													{{$t('khsm.wenti_1')}}
												</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question1" style="line-height: revert; display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shi')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.wenti_1_1')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question1,1)">
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_1_2')" prop="q1_name">
												<el-input :class='obj.question1_1'  v-model="khsm1Form.q1_name" :placeholder="$t('khsm.wenti_1_3')"
													show-word-limit :maxlength="ifEng?30:30"
													@input="checkForm(khsm1Form.q1_name,'q1_name')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="this.$t('khsm.idcardpassnum')" prop="q1_idnumber" >
												<el-input :class='obj.question1_2' v-model="khsm1Form.q1_idnumber"
													:placeholder="this.$t('khsm.idcardpassnuminput')" show-word-limit maxlength="20"
													@input="checkForm(khsm1Form.q1_idnumber,'q1_idnumber')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
								<el-row v-if="Object.is(khsm1Form.question1,1)">
									<el-col :sm="24" :lg="24" >
										<el-form-item :label="this.$t('khsm.address')" prop="q1_address" style="margin-bottom:0.5rem">
											<el-input :class='obj.question1_3' v-model="khsm1Form.q1_address" :placeholder="this.$t('khsm.addressinput')"
												show-word-limit :maxlength="ifEng?130:130"
												@input="checkForm(khsm1Form.q1_address,'q1_address')"></el-input>
										</el-form-item>
									</el-col>
								</el-row>
							</el-collapse-item>
							<!-- 2  4  -->
							<el-collapse-item  name="2" :style="obj.question2 ? 'border:1px solid #ef4c3d':''" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question2'>2.</span> 
									<span  :class='obj.question2'>
										{{$t('khsm.wenti_2')}}
									</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question2">
											<!-- <div slot='label' :class='obj.question2' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question2'>2.</span> 
												<span style="line-height:1rem" :class='obj.question2'>
													{{$t('khsm.wenti_2')}}
												</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question2" style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shitigxx')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div style="width:100%;" v-if="Object.is(khsm1Form.question2,0)">
									<el-row>
										<el-col :sm="24" :lg="24" class="cnLabel unLabel">
											<el-form-item prop="q2_cause" style="margin-bottom: 0.5rem;">
												<el-input :class='obj.question2_1' v-model="khsm1Form.q2_cause"
													:placeholder="this.$t('khsm.qingtigongxiangqing')" show-word-limit
													:maxlength="ifEng?100:50" @input="checkForm(khsm1Form.q2_cause,'q2_cause')">
												</el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
							</el-collapse-item>
							<!-- 3 2 -->
							<el-collapse-item  name="3" :style="obj.question3 ? 'border:1px solid #ef4c3d':''" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question3'>3.</span> 
									<span :class='obj.question3'>
										{{$t('khsm.wenti_3')}}
									</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question3" >
											<!-- <div slot='label' :class='obj.question3' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question3'>3.</span> 
												<span style="line-height:1rem" :class='obj.question3'>
													{{$t('khsm.wenti_3')}}
												</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question3" style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shitigxx')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question3,0)">
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_3_1')" prop="q3_username" style="white-space: nowrap;">
												<el-input :class='obj.question3_1' v-model="khsm1Form.q3_username"
													:placeholder="$t('khsm.wenti_3_5')" show-word-limit
													:maxlength="ifEng?30:30" @input="checkForm(khsm1Form.q3_username,'q3_username')">
												</el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="$t('khsm.wenti_3_2')" prop="q3_relationship">

												<el-input :class='obj.question3_2' v-model="khsm1Form.q3_relationship" :placeholder="$t('khsm.wenti_3_6')"
													show-word-limit :maxlength="ifEng?30:30"
													@input="checkForm(khsm1Form.q3_relationship,'q3_relationship')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question3,0)" >
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_3_3')" prop="q3_username1" style="margin-bottom:0.5rem">
												<el-input :class='obj.question3_3' v-model="khsm1Form.q3_username1"
													:placeholder="$t('khsm.wenti_3_7')" show-word-limit
													:maxlength="ifEng?20:20" @input="checkForm(khsm1Form.q3_username1,'q3_username1')">
												</el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="$t('khsm.wenti_3_4')" prop="q3_relationship1" style="margin-bottom:0.5rem">

												<el-input :class='obj.question3_4' v-model="khsm1Form.q3_relationship1" :placeholder="$t('khsm.wenti_3_8')"
													show-word-limit :maxlength="ifEng?20:20"
													@input="checkForm(khsm1Form.q3_relationship1,'q3_relationship1')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
							</el-collapse-item>
							<!--4 2 -->
							<el-collapse-item  name="4" :style="obj.question4 ? 'border:1px solid #ef4c3d':''" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question4'>4.</span> 
									<span :class='obj.question4'>
										{{$t('khsm.wenti_4')}}
									</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question4" >
											<!-- <div slot='label' :class='obj.question4' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question4'>4.</span> 
												<span :class='obj.question4'>
													{{$t('khsm.wenti_4')}}
												</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question4" style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shitigxx')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question4,0)" >
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_4_1')" prop="q4_username" style="margin-bottom:0.5rem">
												<el-input :class='obj.question4_1' v-model="khsm1Form.q4_username"
													:placeholder="$t('khsm.wenti_4_2')" show-word-limit
													:maxlength="ifEng?30:30" @input="checkForm(khsm1Form.q4_username,'q4_username')">
												</el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="this.$t('khsm.guanxi')" prop="q4_relationship" style="margin-bottom:0.5rem">

												<el-input :class='obj.question4_2' v-model="khsm1Form.q4_relationship" :placeholder="this.$t('khsm.guanxiinput')"
													show-word-limit :maxlength="ifEng?30:30"
													@input="checkForm(khsm1Form.q4_relationship,'q4_relationship')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
							</el-collapse-item>
							<!-- 5 -->
							<el-collapse-item  name="5" :style="obj.question5 ? 'border:1px solid #ef4c3d':''" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question5'>5.</span> 
									<span :class='obj.question5'>
										{{$t('khsm.wenti_5')}}
									</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question5" >
											<!-- <div slot='label' :class='obj.question5' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question5'>5.</span> 
												<span :class='obj.question5'>
													{{$t('khsm.wenti_5')}}
												</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question5"  style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shitigxx')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question5,0)" >
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_5_1')" prop="q5_accountname" style="margin-bottom:0.5rem">
												<el-input :class='obj.question5_1' v-model="khsm1Form.q5_accountname"
													:placeholder="$t('khsm.wenti_5_2')" show-word-limit maxlength="30"
													@input="checkForm(khsm1Form.q5_accountname,'q5_accountname')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="$t('khsm.wenti_5_3')" prop="q5_accountnum" style="margin-bottom:0.5rem">
												<el-input :class='obj.question5_2' v-model="khsm1Form.q5_accountnum"
												:placeholder="$t('khsm.wenti_5_4')" show-word-limit maxlength="30"
													@input="checkForm(khsm1Form.q5_accountnum,'q5_accountnum')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
							</el-collapse-item>
							<!-- 6 5 -->
							<el-collapse-item  name="6" :style="obj.question6 ? 'border:1px solid #ef4c3d':''" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question6'>6.</span> 
									<span :class='obj.question6'>
										{{$t('khsm.wenti_6')}}
									</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question6" >
											<!-- <div slot='label' :class='obj.question6' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question6'>6.</span> 
												<span :class='obj.question6'>
													{{$t('khsm.wenti_6')}}
												</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question6"  style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shitigxx')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question6,0)" >
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_5_1')" prop="q6_accountname" style="margin-bottom:0.5rem">
												<el-input :class='obj.question6_1' v-model="khsm1Form.q6_accountname"
												:placeholder="$t('khsm.wenti_5_2')" show-word-limit :maxlength="30"
													@input="checkForm(khsm1Form.q6_accountname,'q6_accountname')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="$t('khsm.wenti_5_3')" prop="q6_accountnum" style="margin-bottom:0.5rem">
												<el-input :class='obj.question6_2' v-model="khsm1Form.q6_accountnum"
												:placeholder="$t('khsm.wenti_5_4')" show-word-limit maxlength="30"
													@input="checkForm(khsm1Form.q6_accountnum,'q6_accountnum')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
							</el-collapse-item>
							<!-- 7 5 -->
							<el-collapse-item  name="7" :style="obj.question7 ? 'border:1px solid #ef4c3d':''" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question7'>7.</span> 
									<span :class='obj.question7'>
										{{$t('khsm.wenti_7')}}
									</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question7" >
											<!-- <div slot='label' :class='obj.question7' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question7'>7.</span> 
												<span :class='obj.question7'>
													{{$t('khsm.wenti_7')}}
												</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question7"  style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shitigxx')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question7,0)">
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_7_1')" prop="q7_accountname">
												<el-input :class='obj.question7_1' v-model="khsm1Form.q7_accountname"
												:placeholder="$t('khsm.wenti_7_2')" show-word-limit :maxlength="30"
													@input="checkForm(khsm1Form.q7_accountname,'q7_accountname')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="$t('khsm.wenti_7_3')" prop="q7_contact">
												<el-input :class='obj.question7_2' v-model="khsm1Form.q7_contact"
												:placeholder="$t('khsm.wenti_7_4')" show-word-limit maxlength="30"
													@input="checkForm(khsm1Form.q7_contact,'q7_contact')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question7,0)" >
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.wenti_5_3')" prop="q7_accountnum" style="margin-bottom:0.5rem">
												<el-input :class='obj.question7_3' v-model="khsm1Form.q7_accountnum"
												:placeholder="$t('khsm.wenti_5_4')" show-word-limit maxlength="30"
													@input="checkForm(khsm1Form.q7_accountnum,'q7_accountnum')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
							</el-collapse-item>
							<!-- 8 -6 -->
							<el-collapse-item  name="8" :style="obj.question8 ? 'border:1px solid #ef4c3d':''" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question8'>8.</span> 
									<span :class='obj.question8'>
										{{$t('khsm.wenti_8')}}
									</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question8" >
											<!-- <div slot='label' :class='obj.question8'>8. 客戶是否為「美國公民」（即持有「美國護照」）或就稅務目的而言的「美國居民」（即持有「美國綠卡」）?</div> -->
											<!-- <div slot='label' :class='obj.question8' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question8'>8.</span> 
												<span :class='obj.question8'>
													{{$t('khsm.wenti_8')}}
												</span>
											</div> -->
											<el-radio-group @change="eightClick(khsm1Form.question8)" v-model="khsm1Form.question8" style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shi')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
							</el-collapse-item>
							<!-- 9 -->
							<el-collapse-item  name="9" :style="obj.question9 ? 'border:1px solid #ef4c3d':''" style="margin-bottom:20px" class="redClass">
								<div slot='title' style="display: flex;">
									<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question9'>9.</span> 
									<span :class='obj.question9'>{{$t('khsm.wenti_9')}}</span>
								</div>
								<el-row>
									<el-col :sm="24" :lg="24">
										<el-form-item prop="question9">
											<!-- <div slot='label' :class='obj.question9' style="display:flex">
												<span style="flex-shrink: 0;margin-right: 5px;" :class='obj.question9'>9.</span> 
												<span :class='obj.question9'>{{$t('khsm.wenti_9')}}</span>
											</div> -->
											<el-radio-group v-model="khsm1Form.question9" style="line-height: revert;display: flex;align-items: center;">
												<el-radio :label="0" style="margin-right:10%">{{$t('khsm.shitigxx')}}</el-radio><br>
												<el-radio :label="1">{{$t('khsm.fou')}}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<div v-if="Object.is(khsm1Form.question9,0)">
									<div>{{$t('khsm.wenti_9_1')}}</div>
									<div style="margin-top:0.3rem">{{$t('khsm.wenti_9_2')}}</div>
								</div>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question9,0)">
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<el-form-item :label="$t('khsm.sqrsmc')" prop="q9_username">
												<el-input :class='obj.question9_1' v-model="khsm1Form.q9_username"
												:placeholder="$t('khsm.qsrsqrsmc')"  show-word-limit
													:maxlength="ifEng?30:30" @input="checkForm(khsm1Form.q9_username,'q9_username')">
												</el-input>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="$t('khsm.sqrsid')" prop="q9_relationship">
												<el-input :class='obj.question9_2' v-model="khsm1Form.q9_relationship" :placeholder="$t('khsm.qsrsqrsid')"
													show-word-limit maxlength="20"
													@input="checkForm(khsm1Form.q9_relationship,'q9_relationship')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
								<div style="width:100%;display: flex;" v-if="Object.is(khsm1Form.question9,0)">
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14">
											<div class="abc">
												<el-form-item :label="$t('khsm.zhcyr')" prop="q9_username1" style="margin-bottom:0.5rem">
													<el-input :class='obj.question9_3' v-model="khsm1Form.q9_username1"
													:placeholder="$t('khsm.qsrzhcyr')" show-word-limit
														:maxlength="ifEng?30:30" @input="checkForm(khsm1Form.q9_username1,'q9_username1')">
													</el-input>
												</el-form-item>
											</div>
										</el-col>
									</el-row>
									<el-row style="width: 50%;">
										<el-col :sm="24" :lg="14" style="float: right;">
											<el-form-item :label="$t('khsm.sqrsphone')" prop="q9_relationship1" style="margin-bottom:0.5rem">
												<el-input :class='obj.question9_4' v-model="khsm1Form.q9_relationship1" :placeholder="$t('khsm.qsrsqrsphone')"
													show-word-limit maxlength="20"
													@input="checkForm(khsm1Form.q9_relationship1,'q9_relationship1')"></el-input>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>

					<div class="titleCal" style="background: #3d7077;">
						<img style="position: relative; top: 2px;" src="../../image/titleImg.png" alt="">
						<span style="color:#ffffff;margin-left: 10px;">{{ this.$t("khsm.querenjiqianshu") }}</span>
					</div>
					<div class="ListView khxy grxxBorder" style="background: #f0f7f0;" :style="wjFlag || signFlag?'border:1px solid #ef4c3d;border-top:none':''">
						<!-- 部署正式 -->
						<div style="line-height: 1rem;" v-if="!ifEng">
							{{ this.$t("khsm.wenti_a_1") }}
							<!-- (1)<a :class="pdfviewBol.form1?'aUnColor':'aOnColor'"
								:href="ifEng?' https://hk.qmisit.com/accopen/accountOpening?lan=eng&token='+this.$store.state.token+'':' https://hk.qmisit.com/accopen/accountOpening?lan=big5&token='+this.$store.state.token+''"
								target="_blank" @click="pdfviewBol.form1=true">{{ this.$t("khsm.wenti_a_2") }}</a>; -->
							(1)
							<a :class="pdfviewBol.form1?'aUnColor':'aOnColor'"
								:href="ifEng?' http://202.130.113.149/accopen/accountOpening?lan=eng&token='+this.$store.state.token+'':' http://202.130.113.149/accopen/accountOpening?lan=big5&token='+this.$store.state.token+''"
								target="_blank" @click="pdfviewBol.form1=true" >{{ this.$t("khsm.wenti_a_2") }}</a>;
							(2)
							<a :class="pdfviewBol.form2?'aUnColor':'aOnColor'"
								:href="ifEng?'https://hk.qmisit.com/app/html/fxplsm_en_test_web.html':'https://hk.qmisit.com/app/html/fxplsm_test_web.html'"
								target="_blank" @click="pdfviewBol.form2=true">{{ this.$t("khsm.wenti_a_3") }}</a>;
							(3)
							<a :class="pdfviewBol.form3?'aUnColor':'aOnColor'"
								:href="ifEng?'https://hk.qmisit.com/app/html/grzl_en_test_web.html':'https://hk.qmisit.com/app/html/grzl_test_web.html'"
								target="_blank" @click="pdfviewBol.form3=true">{{ this.$t("khsm.wenti_a_4") }}</a>;
							(4)
							<a :class="pdfviewBol.form4?'aUnColor':'aOnColor'" :href="ifEng?' http://202.130.113.149:3785/kaihu/getW8benPdf?lan=eng&token='+this.$store.state.token+'':' http://202.130.113.149:3785/kaihu/getW8benPdf?lan=big5&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form4=true">申報美國稅務狀況表格（非美國公民身份證明）</a>;
							<!-- (4)
							<a :class="pdfviewBol.form4?'aUnColor':'aOnColor'" :href="ifEng?' https://hk.qmisit.com:3785/kaihu/getW8benPdf?lan=eng&token='+this.$store.state.token+'':' https://hk.qmisit.com:3785/kaihu/getW8benPdf?lan=big5&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form4=true">申報美國稅務狀況表格（非美國公民身份證明）</a>; -->
									
							(5)
							<a :class="pdfviewBol.form5?'aUnColor':'aOnColor'" href="https://hk.qmisit.com/app/CRS-I(HK).pdf"
									target="_blank" @click="pdfviewBol.form5=true">{{ this.$t("khsm.wenti_a_5") }}</a>;
							<!-- (6)
							<a :class="pdfviewBol.form6?'aUnColor':'aOnColor'" :href="'https://hk.qmisit.com:3785/kaihu/getHKIDRReformPdf?token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form6=true">{{ this.$t("khsm.wenti_a_6") }}</a>; -->
							<!-- (7)
							<a :class="pdfviewBol.form7?'aUnColor':'aOnColor'" :href="'https://hk.qmisit.com:3785/kaihu/getOtcPdf?lan=big5&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form7=true">{{ this.$t("khsm.wenti_a_7") }}</a>. -->
							(6)
							<a :class="pdfviewBol.form6?'aUnColor':'aOnColor'" :href="'http://202.130.113.149:3785/kaihu/getHKIDRReformPdf?token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form6=true">{{ this.$t("khsm.wenti_a_6") }}</a>;
							<!-- (7)
							<a :class="pdfviewBol.form7?'aUnColor':'aOnColor'" :href="'http://202.130.113.149:3785/kaihu/getOtcPdf?lan=big5&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form7=true">{{ this.$t("khsm.wenti_a_7") }}</a>. -->
						</div>
						<div style="line-height: 1rem;" v-else>
							{{ this.$t("khsm.wenti_a_1") }}
							<!-- (1)<a :class="pdfviewBol.form1?'aUnColor':'aOnColor'"
								:href="ifEng?' https://hk.qmisit.com/accopen/accountOpening?lan=eng&token='+this.$store.state.token+'':' https://hk.qmisit.com/accopen/accountOpening?lan=big5&token='+this.$store.state.token+''"
								target="_blank" @click="pdfviewBol.form1=true">{{ this.$t("khsm.wenti_a_2") }}</a>; -->
							(1)
							<a :class="pdfviewBol.form1?'aUnColor':'aOnColor'"
								:href="ifEng?' http://202.130.113.149/accopen/accountOpening?lan=eng&token='+this.$store.state.token+'':' http://202.130.113.149/accopen/accountOpening?lan=big5&token='+this.$store.state.token+''"
								target="_blank" @click="pdfviewBol.form1=true">{{ this.$t("khsm.wenti_a_2") }}</a>;
							(2)
							<a :class="pdfviewBol.form2?'aUnColor':'aOnColor'"
								:href="ifEng?'https://hk.qmisit.com/app/html/fxplsm_en_test_web.html':'https://hk.qmisit.com/app/html/fxplsm_test_web.html'"
								target="_blank" @click="pdfviewBol.form2=true">{{ this.$t("khsm.wenti_a_3") }}</a>;
							(3)
							<a :class="pdfviewBol.form3?'aUnColor':'aOnColor'"
								:href="ifEng?'https://hk.qmisit.com/app/html/grzl_en_test_web.html':'https://hk.qmisit.com/app/html/grzl_test_web.html'"
								target="_blank" @click="pdfviewBol.form3=true">{{ this.$t("khsm.wenti_a_4") }}</a>;
							(4)
							<a :class="pdfviewBol.form4?'aUnColor':'aOnColor'" :href="ifEng?' http://202.130.113.149:3785/kaihu/getW8benPdf?lan=eng&token='+this.$store.state.token+'':' http://202.130.113.149:3785/kaihu/getW8benPdf?lan=big5&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form4=true">Form W-8BEN</a> and
							<!-- (4)
							<a :class="pdfviewBol.form4?'aUnColor':'aOnColor'" :href="ifEng?' https://hk.qmisit.com:3785/kaihu/getW8benPdf?lan=eng&token='+this.$store.state.token+'':' https://hk.qmisit.com:3785/kaihu/getW8benPdf?lan=big5&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form4=true">Form W-8BEN</a> and -->
							(5)
							<a :class="pdfviewBol.form5?'aUnColor':'aOnColor'" href="https://hk.qmisit.com/app/CRS-I(HK).pdf"
									target="_blank" @click="pdfviewBol.form5=true">{{ this.$t("khsm.wenti_a_5") }}</a>;
							<!-- (6)
							<a :class="pdfviewBol.form6?'aUnColor':'aOnColor'" :href="'https://hk.qmisit.com:3785/kaihu/getHKIDRReformPdf?token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form6=true">{{ this.$t("khsm.wenti_a_6") }}</a>; -->
							<!-- (7)
							<a :class="pdfviewBol.form7?'aUnColor':'aOnColor'" :href="'https://hk.qmisit.com:3785/kaihu/getOtcPdf?lan=eng&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form7=true">{{ this.$t("khsm.wenti_a_7") }}</a>. -->
							(6)
							<a :class="pdfviewBol.form6?'aUnColor':'aOnColor'" :href="'http://202.130.113.149:3785/kaihu/getHKIDRReformPdf?token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form6=true">{{ this.$t("khsm.wenti_a_6") }}</a>;
							<!-- (7)
							<a :class="pdfviewBol.form7?'aUnColor':'aOnColor'" :href="'http://202.130.113.149:3785/kaihu/getOtcPdf?lan=eng&token='+this.$store.state.token+''"
									target="_blank" @click="pdfviewBol.form7=true">{{ this.$t("khsm.wenti_a_7") }}</a>. -->
						</div>
						<div style="margin-top:1rem;line-height: 1rem;">
							{{ this.$t("khsm.wenti_b") }}
						</div>
						<div class="toRadioCheckBox xyDivView" style="display:flex;align-items: center;">
							<el-form-item prop="check" >
								<el-checkbox @change="agree" v-model="khsm1Form.checked" v-if="!ifEng">
									<div v-if="firstnum === 0">
										{{this.$t('khsm.bryydbtykhxy')}}
									</div>
									<div v-else :class="[wjFlag?'red_colors':'']">
										{{this.$t('khsm.bryydbtykhxy')}}
									</div>
								</el-checkbox>
								<div style="display:flex" v-else>
									<el-checkbox @change="agree" v-model="khsm1Form.checked" >
									</el-checkbox>
									<div style="width:100%;margin-left: 10px;" v-if="firstnum === 0">
										{{this.$t('khsm.bryydbtykhxy')}}
									</div>
									<div style="width:100%;margin-left: 10px;" v-else :class="[wjFlag?'red_colors':'']">
										{{this.$t('khsm.bryydbtykhxy')}}
									</div>
								</div>
							</el-form-item>
							<div class="signCal" v-if="!ifEng">
								<span @click="signClick()">
									<img style="margin-right: 5px; position: relative;top: 3px;" src="../../image/sign.png" alt="">
									<span :style="signFlag?'color:#ef4c3d;':'color:#22978d'">{{ this.$t("khsm.qs") }}</span> 
								</span>
								<el-image 
									v-if="picname"
									style="margin-left: 10px; position: relative;top: 0px; height:22px;"
									:src="require('../../image/guidang/icon3.png')"
									class="my_logo"
									:preview-src-list="signimageArr">
								</el-image>
							</div>
							<div class="signCal" style="flex-shrink: 0; width: 15%;" v-else>
								<span @click="signClick()">
									<img style="margin-right: 5px; position: relative;top: 3px;" src="../../image/sign.png" alt="">
									<span :style="signFlag?'color:#ef4c3d;':'color:#22978d'">{{ this.$t("khsm.qs") }}</span> 
								</span>
								<el-image 
									v-if="picname"
									style="margin-left: 10px; position: relative;top: 0px; height:22px;"
									:src="require('../../image/guidang/icon3.png')"
									class="my_logo"
									:preview-src-list="signimageArr">
								</el-image>
							</div>
						</div>
					</div>
					<div style="display:flex;">
						<button type="button" class="subBtn" @click="backFn">{{$t('login.fanhui')}}</button>
						<button type="button" class="subBtn" @click="resetFn">{{$t('login.chongzhi')}}</button>
						<!-- <button type="button" class="subBtn">{{$t('login.cucun')}}</button> -->
						<!-- <button type="button" class="subBtn" @click="nextFn">{{$t('login.jixu')}}</button> -->
						<el-button class="subBtn" @click="nextFn" v-loading.fullscreen.lock="fullscreenLoading">{{$t('login.jixu')}}</el-button>
					</div>
					<div class="artboard" v-if="openFlag">
						<div class="canvaTop">{{ this.$t("khsm.khqs") }}<span class="canvaClose" @click="handleClose">X</span> </div>
						<vue-esign ref="esign" style="border:1px solid #e5e5e5;margin: 32px;box-shadow: 0 0 15px #cbc9c9;" :width="800" :height="300" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :isClearBgColor="false" :bgColor.sync="bgColor" />
						<div style="text-align: center;margin-bottom: 4%;">
							<span @click="handleReset" class="canvaOk" style="background: #ED4849;">{{ this.$t("khsm.qc") }}</span>
							<span @click="handleGenerate" class="canvaOk" style="margin-left: 15%;">{{ this.$t("khsm.wc") }}</span>
						</div>
					</div>
					<div class="artboardBack" v-if="openFlag"></div>
				</el-form>
			</div>

		</div>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		<Messwarn ref='Messwarn'></Messwarn>
		<language></language>
	</div>
</template>
<script>
	import tabBar from '@/components/tabBar'

	import https from '@/plugins/http.js';

	import apiUrl from '@/assets/api.js';

	import App from '@/assets/app.js';

	import $ from 'jquery';

	import directory from "@/components/directory";

    import language from '../main/mains.vue';

	export default {
		components: {
			tabBar,
			directory,
            language
		},
		data() {
			var question1 = (rule, value,callback) => {

				if(value === 0 || value === 1){
					this.$set(this.obj,'question1',"")
				}else{
					this.$set(this.obj,'question1',"red_color")
				}
				callback();
			};
			var question2 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question2',"")
				}else{
					this.$set(this.obj,'question2',"red_color")
				}
				callback();
			};
			var question3 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question3',"")
				}else{
					this.$set(this.obj,'question3',"red_color")
				}
				callback();
			};
			var question4 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question4',"")
					callback();
				}else{
					this.$set(this.obj,'question4',"red_color")
					callback();
				}
			};
			var question5 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question5',"")
					callback();
				}else{
					this.$set(this.obj,'question5',"red_color")
					callback();
				}
			};
			var question6 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question6',"")
				}else{
					this.$set(this.obj,'question6',"red_color")
				}
				callback();
			};
			var question7 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question7',"")
				}else{
					this.$set(this.obj,'question7',"red_color")
				}
				callback();
			};
			var question8 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question8',"")
				}else{
					this.$set(this.obj,'question8',"red_color")
				}
				callback();
			};
			var question9 = (rule, value,callback) => {
				if(value === 0 || value === 1){
					this.$set(this.obj,'question9',"")
				}else{
					this.$set(this.obj,'question9',"red_color")
				}
				callback();
			};
			return {
				location:'',
				activeNames: [],
				fullscreenLoading:false,
				signimageArr:[],
				lineWidth: 6,
				lineColor: '#000000',
				bgColor: '#ffffff',
				resultImg: '',
				isCrop: false,
				openFlag:false,
				handitem:0,
				firstnum:0,
				picname:'',
				signFlag:false,
				wjFlag:false,
				obj: {
					question1: "",
					question1_1: "",
					question1_2: "",
					question1_3: "",
					question2: "",
					question2_1: "",
					question3: "",
					question3_1: "",
					question3_2: "",
					question3_3: "",
					question3_4: "",
					question4: "",
					question4_1: "",
					question4_2: "",
					question5: "",
					question5_1: "",
					question5_2: "",
					question6: "",
					question6_1: "",
					question6_2: "",
					question7: "",
					question7_1: "",
					question7_2: "",
					question7_3: "",
					question8: "",
					question9: "",
					question9_1: "",
					question9_2: "",
					question9_3: "",
					question9_4: "",
				},
				ifEng: this.$i18n.locale == 'eng',
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				rules: {
					question1: [{
						validator: question1,
						trigger: ['blur', 'change']
					}],
					q1_name: [{
						required: true,
						message: ' ',//this.$t('khsm.mingchenginput'),
						trigger: ['blur', 'change']
					}, ],
					q1_idnumber: [{
						required: true,
						message: ' ',//this.$t('khsm.idcardpassnuminput'),
						trigger: ['blur', 'change']
					}, ],
					q1_address: [{
						required: true,
						message: ' ',//this.$t('khsm.addressinput'),
						trigger: ['blur', 'change']
					}, ],
					question2: [{
						validator: question2,
						trigger: ['blur', 'change']
					}],
					q2_cause: [{
						required: true,
						message: ' ',//this.$t('khsm.qingtigongxiangqing'),
						trigger: ['blur', 'change']
					}, ],
					question3: [{
						validator: question3,
						trigger: ['blur', 'change']
					}],
					q3_username: [{
						required: true,
						message: ' ',//this.$t('khsm.guyudailirennameinput'),
						trigger: ['blur', 'change']
					}, ],
					q3_relationship: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					q3_username1: [{
						required: true,
						message: ' ',//this.$t('khsm.guyudailirennameinput'),
						trigger: ['blur', 'change']
					}, ],
					q3_relationship1: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					question4: [{
						validator: question4,
						trigger: ['blur', 'change']
					}],
					q4_username: [{
						required: true,
						message: ' ',//this.$t('khsm.guyudailirennameinput'),
						trigger: ['blur', 'change']
					}, ],
					q4_relationship: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					question5: [{
						validator: question5,
						trigger: ['blur', 'change']
					}],
					q5_accountname: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					q5_accountnum: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					question6: [{
						validator: question6,
						trigger: ['blur', 'change']
					}],
					q6_accountname: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					q6_accountnum: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					question7: [{
						validator: question7,
						trigger: ['blur', 'change']
					}],
					q7_accountname: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					q7_accountnum: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					question8: [{
						validator: question8,
						trigger: ['blur', 'change']
					}],
					question9: [{
						validator: question9,
						trigger: ['blur', 'change']
					}],
					q9_username: [{
						required: true,
						message: ' ',//this.$t('khsm.guyudailirennameinput'),
						trigger: ['blur', 'change']
					}, ],
					q9_relationship: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
					q9_username1: [{
						required: true,
						message: ' ',//this.$t('khsm.guyudailirennameinput'),
						trigger: ['blur', 'change']
					}, ],
					q9_relationship1: [{
						required: true,
						message: ' ',//this.$t('khsm.guanxiinput'),
						trigger: ['blur', 'change']
					}, ],
				},
				pdfviewBol: {
					form1: false,
					form2: false,
					form3: false,
					form4: false,
					form5: false,
					form6: false,
					// form7: false,
				},
				khsm1Form: {
					question1: '',
					question2: '',
					question3: '',
					question4: '',
					question5: '',
					question6: '',
					question7: '',
					question8: '',
					question9: '',
					q1_name: '',
					q1_idnumber: '',
					q1_address: '',
					q2_cause: null,
					q3_username: null,
					q3_relationship: null,
					q3_username1: null,
					q3_relationship1: null,
					q4_username: null,
					q4_relationship: null,
					q5_accountnum: null,
					q5_accountname: null,
					q5_contact: null,
					q6_accountnum: null,
					q6_accountname: null,
					q7_accountnum: null,
					q7_accountname: null,
					q7_contact: null,
					q9_username: null,
					q9_relationship: null,
					q9_username1: null,
					q9_relationship1: null,
					
					// 11
					// q2_username: null,
					// q2_relationship: null,
					// q3_organization: null,
					// q3_image: null,
					// q4_cause: null,
					// q5_accountnum: null,
					// q5_accountname: null,
					// q5_contact: null,
					checked: false,
					check: null
				},
			};
		},
		beforeCreate() {
			let _this = this;
			https.fetchLoginPost(apiUrl.getWEBMsg, {
				token: _this.$store.state.token,
				language: localStorage.lang,
				nowstep: 5
			}).then((data) => {
				if (Object.is(data.qmiscode, 1000)) {
					if (data.moveto == 9) {
						_this.$router.push({
							path: '/main/finish'
						});
						return;
					} else {
						let result = data.detail
						if (result) {
							if (result.question1!=null) {
								_this.khsm1Form.question1 = result.question1;
							}
							if (result.q1_name) {
								_this.khsm1Form.q1_name = result.q1_name;
							}
							if (result.q1_idnumber) {
								_this.khsm1Form.q1_idnumber = result.q1_idnumber;
							}
							if (result.q1_address) {
								_this.khsm1Form.q1_address = result.q1_address;
							}
							if (result.question2!=null) {
								_this.khsm1Form.question2 = result.question2;
							}
							if (result.q2_details) {
								_this.khsm1Form.q2_cause = result.q2_details;
							}
							if (result.question3!=null) {
								_this.khsm1Form.question3 = result.question3;
							}
							if (result.q3_organization) {
								_this.khsm1Form.q3_username = result.q3_organization;
							}
							if (result.q3_position) {
								_this.khsm1Form.q3_relationship = result.q3_position;
							}
							if (result.q3_personal_csrcnum) {
								_this.khsm1Form.q3_username1 = result.q3_personal_csrcnum;
							}
							if (result.q3_company_csrcnum) {
								_this.khsm1Form.q3_relationship1 = result.q3_company_csrcnum;
							}
							if (result.question4!=null) {
								_this.khsm1Form.question4 = result.question4;
							}
							if (result.q4_name) {
								_this.khsm1Form.q4_username = result.q4_name;
							}
							if (result.q4_contact) {
								_this.khsm1Form.q4_relationship = result.q4_contact;
							}
							if (result.question5!=null) {
								_this.khsm1Form.question5 = result.question5;
							}
							if (result.q5_name) {
								_this.khsm1Form.q5_accountname = result.q5_name;
							}
							if (result.q5_accountnum) {
								_this.khsm1Form.q5_accountnum = result.q5_accountnum;
							}
							if (result.question6!=null) {
								_this.khsm1Form.question6 = result.question6;
							}
							if (result.q6_name) {
								_this.khsm1Form.q6_accountname = result.q6_name;
							}
							if (result.q6_accountnum) {
								_this.khsm1Form.q6_accountnum = result.q6_accountnum;
							}
							if (result.question7!=null) {
								_this.khsm1Form.question7 = result.question7;
							}
							if (result.q7_accountname) {
								_this.khsm1Form.q7_accountnum = result.q7_accountname;
							}
							if (result.q7_accounttype) {
								_this.khsm1Form.q7_accountname = result.q7_accounttype;
							}
							if (result.q7_accountnum) {
								_this.khsm1Form.q7_contact = result.q7_accountnum;
							}
							if (result.question8!=null) {
								_this.khsm1Form.question8 = result.question8;
							}
							if (result.question9!=null) {
								_this.khsm1Form.question9 = result.question9;
							}
							if (result.q9_name) {
								_this.khsm1Form.q9_username = result.q9_name;
							}
							if (result.q9_idnumber) {
								_this.khsm1Form.q9_relationship = result.q9_idnumber;
							}
							if (result.q9_contact) {
								_this.khsm1Form.q9_username1 = result.q9_contact;
							}
							if (result.q9_phonenum) {
								_this.khsm1Form.q9_relationship1 = result.q9_phonenum;
							}
							if (result.qianmingpic) {
								_this.picname = result.qianmingpic;
							}
							if (result.qianmingpicpath) {
								_this.signimageArr = [];
								_this.signimageArr.push(result.qianmingpicpath);
							}
							// if (result.question1 != null) {
							// 	_this.khsm1Form.question1 = result.question1
							// }
							// if (result.question2 != null) {
							// 	_this.khsm1Form.question2 = result.question2
							// }
							// if (result.question3 != null) {
							// 	_this.khsm1Form.question3 = result.question3
							// }
							// if (result.question4 != null) {
							// 	_this.khsm1Form.question4 = result.question4
							// }
							// if (result.question5 != null) {
							// 	_this.khsm1Form.question5 = result.question5
							// }
							// if (result.question6 != null) {
							// 	_this.khsm1Form.question6 = result.question6
							// }
							if (result.question1 != null && result.question2 != null && result.question3 != null &&
								result.question4 != null && result.question5 != null && result.question6 != null) {
								_this.pdfviewBol.form1 = true;
								_this.pdfviewBol.form2 = true;
								_this.pdfviewBol.form3 = true;
								_this.pdfviewBol.form4 = true;
								_this.pdfviewBol.form5 = true;
								_this.pdfviewBol.form6 = true;
								// _this.pdfviewBol.form7 = true;
								_this.khsm1Form.checked = true;
							}
							// if (result.q1_name) {
							// 	_this.khsm1Form.q1_name = result.q1_name
							// }
							// if (result.q1_idnumber) {
							// 	_this.khsm1Form.q1_idnumber = result.q1_idnumber
							// }
							// if (result.q1_address) {
							// 	_this.khsm1Form.q1_address = result.q1_address
							// }
							// if (result.q2_username) {
							// 	_this.khsm1Form.q2_username = result.q2_username
							// }
							// if (result.q2_relationship) {
							// 	_this.khsm1Form.q2_relationship = result.q2_relationship
							// }
							// if (result.q3_organization) {
							// 	_this.khsm1Form.q3_organization = result.q3_organization
							// }
							// if (result.q3_image) {
							// 	_this.khsm1Form.q3_image = result.q3_image
							// }
							// if (result.q4_cause) {
							// 	_this.khsm1Form.q4_cause = result.q4_cause
							// }
							// if (result.q5_accountnum) {
							// 	_this.khsm1Form.q5_accountnum = result.q5_accountnum
							// }
							// if (result.q5_accountname) {
							// 	_this.khsm1Form.q5_accountname = result.q5_accountname
							// }
							// if (result.q5_contact) {
							// 	_this.khsm1Form.q5_contact = result.q5_contact
							// }
							// if (result.q3Imagepath) {
							// 	_this.dialogImageUrl = result.q3Imagepath
							// }
						}
					}
				} else if (Object.is(data.qmiscode, 3000) || Object.is(data.qmiscode, 2000)) {
					_this.$refs['Messwarn'].SendMessage(data.qmismsg)
					setTimeout(() => {
						location.href = this.$store.state.urlapi
					}, 1500);
				} else {
					_this.$refs['Messwarn'].SendMessage(data.qmismsg)
				}
			}).catch(err => {
				console.log(err);
			});
		},
		watch:{
			firstnum :{
				handler(val){
					console.log(val)
				}
				,immediate:true,
			}
		},
		created() {

		},
		mounted() {
			this.location = location.protocol == 'https';
		},
		methods: {
			handleClose(){
				this.openFlag = false
			},
			 handleReset () {
				console.log(2131);
				this.$refs['esign'].reset() //清空画布
				
			},
			handleGenerate () {
				this.$refs['esign'].generate().then(res => {
					this.resultImg = res // 得到了签字生成的base64图片
					var file = this.dataURLtoFile(this.resultImg);
					console.log(file);
					this.agreeEvent(file)
				}).catch(err => { //  没有签名，点击生成图片时调用
				this.$message({
					message:this.ifEng?'Not Signed':'未簽署',
					type: 'warning'
				})
				// alert(err) // 画布没有签字时会执行这里 'Not Signned'
				
				})
			},

			dataURLtoFile: function(dataurl, filename){ 
				var arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new File([u8arr], filename, { type: mime });
			},

			agreeEvent(file) {
				let data = new FormData();
				data.append("token", this.$store.state.token);
				data.append("file", file);
				data.append("type", 'qianmingimage');
				data.append("language", localStorage.getItem('lang'));
				https.fetchLoginPost(apiUrl.uploadPic, data).then((data) => {
					if (Object.is(data.qmiscode, 1000)) {
						this.picname = data.picname;
						this.signimageArr = [];
						this.signimageArr.push(data.picurl)
						this.signFlag = false;
						console.log(this.picname);
						this.openFlag = false;
					}else if(Object.is(data.qmiscode, 3000) || Object.is(data.qmiscode, 2000)) {
						this.$refs['Messwarn'].SendMessage(data.qmismsg)
						setTimeout(() => {
							location.href = this.$store.state.urlapi
						}, 1500);
					}else {
						App.oTool.warningT(data.qmismsg);
					}
				})
				.catch((err) => {
					console.log(err);
				});
			},


			signClick(){
				console.log("点击的是签名");
				this.openFlag = true
			},
			checkForm(data, tab) {
				console.log("_this.ifEng:" + this.ifEng)
				if (this.ifEng) {
					data = data.replace(/[\u4e00-\u9fa5]+/g, "");
					if (data == "") {
						data = " "
					}
				}
				if (data && tab == "q1_name") {
					this.$set(this.obj,'question1_1',"")
					this.$set(this.obj,'question1',"")
					this.khsm1Form.q1_name = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ").replace(
						/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q1_idnumber") {
					this.$set(this.obj,'question1_2',"")
					this.$set(this.obj,'question1',"")
					this.khsm1Form.q1_idnumber = data.replace(/[^A-Za-z0-9]+/g, "").replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q1_address") {
					this.$set(this.obj,'question1_3',"")
					this.$set(this.obj,'question1',"")
					this.khsm1Form.q1_address = data.replace(/(\n)/g, "").replace(/(\t)/g, "").replace(/(\r)/g, "")
						.replace(/<\/?[^>]*>/g, "").replace(/\s+/g, " ").replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q2_cause") {
					this.$set(this.obj,'question2_1',"")
					this.$set(this.obj,'question2',"")
					return;
				}
				if (data && tab == "q3_username") {
					this.$set(this.obj,'question3_1',"")
					this.$set(this.obj,'question3',"")
					this.khsm1Form.q3_username = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q3_relationship") {
					this.$set(this.obj,'question3_2',"")
					this.$set(this.obj,'question3',"")
					this.khsm1Form.q3_relationship = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q3_username1") {
					this.$set(this.obj,'question3_3',"")
					this.$set(this.obj,'question3',"")
					this.khsm1Form.q3_username1 = data.replace(/[^A-Za-z0-9]+/g, "").replace(/(^\s*)/g, '');
					// this.khsm1Form.q3_username = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
					// 	.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q3_relationship1") {
					this.$set(this.obj,'question3_4',"")
					this.$set(this.obj,'question3',"")
					this.khsm1Form.q3_relationship1 = data.replace(/[^A-Za-z0-9]+/g, "").replace(/(^\s*)/g, '');
					// this.khsm1Form.q3_relationship = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
					// 	.replace(/(^\s*)/g, '');
					return;
				}
				
				if (data && tab == "q4_relationship") {
					this.$set(this.obj,'question4_2',"")
					this.$set(this.obj,'question4',"")
					this.khsm1Form.q4_relationship = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q4_username") {
					this.$set(this.obj,'question4_1',"")
					this.$set(this.obj,'question4',"")
					this.khsm1Form.q4_username = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q5_accountname") {
					this.$set(this.obj,'question5_1',"")
					this.$set(this.obj,'question5',"")
					this.khsm1Form.q5_accountname = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q5_accountnum") {
					this.$set(this.obj,'question5_2',"")
					this.$set(this.obj,'question5',"")
					// this.khsm1Form.q5_accountnum = data.replace(/[^A-Za-z0-9]+/g, "");
					this.khsm1Form.q5_accountnum = data.replace(/[^0-9|\s]+/g, "").replace(/\s+/g, "");
					return;
				}
				if (data && tab == "q6_accountname") {
					this.$set(this.obj,'question6_1',"")
					this.$set(this.obj,'question6',"")
					this.khsm1Form.q6_accountname = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q6_accountnum") {
					this.$set(this.obj,'question6_2',"")
					this.$set(this.obj,'question6',"")
					// this.khsm1Form.q6_accountnum = data.replace(/[^A-Za-z0-9]+/g, "");
					this.khsm1Form.q6_accountnum = data.replace(/[^0-9|\s]+/g, "").replace(/\s+/g, "");
					return;
				}
				if (data && tab == "q7_accountname") {
					this.$set(this.obj,'question7_1',"")
					this.$set(this.obj,'question7',"")
					this.khsm1Form.q7_accountname = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q7_contact") {
					this.$set(this.obj,'question7_2',"")
					this.$set(this.obj,'question7',"")
					// this.khsm1Form.q7_accountname = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
					// 	.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q7_accountnum") {
					this.$set(this.obj,'question7_3',"")
					this.$set(this.obj,'question7',"")
					// this.khsm1Form.q7_accountnum = data.replace(/[^A-Za-z0-9]+/g, "");
					this.khsm1Form.q7_accountnum = data.replace(/[^0-9|\s]+/g, "").replace(/\s+/g, "");
					return;
				}
				if (data && tab == "q9_username") {
					this.$set(this.obj,'question9_1',"")
					this.$set(this.obj,'question9',"")
					this.khsm1Form.q9_username = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q9_relationship") {
					this.$set(this.obj,'question9_2',"")
					this.$set(this.obj,'question9',"")
					this.khsm1Form.q9_relationship = data.replace(/[^A-Za-z0-9]+/g, "").replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q9_username1") {
					this.$set(this.obj,'question9_3',"")
					this.$set(this.obj,'question9',"")
					this.khsm1Form.q9_username1 = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q9_relationship1") {
					this.$set(this.obj,'question9_4',"")
					this.$set(this.obj,'question9',"")
					// this.khsm1Form.q9_relationship1 = data.replace(/[^A-Za-z0-9]+/g, "").replace(/(^\s*)/g, '');
					this.khsm1Form.q9_relationship1 = data.replace(/[^0-9|\s]+/g, "").replace(/\s+/g, "");
					return;
				}

				
				
				if (data && tab == "q5_contact") {
					this.khsm1Form.q5_contact = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}
				if (data && tab == "q3_organization") {
					this.khsm1Form.q3_organization = data.replace(/[^\u4e00-\u9fa5A-Za-z|\s]+/g, "").replace(/\s+/g, " ")
						.replace(/(^\s*)/g, '');
					return;
				}

				// data.replace(/[^A-Za-z0-9]+/g, "")
			},
			handleRemove(file) {
				console.log(file);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.khsm1Form.q3_image = file.name
				this.dialogVisible = true;
			},
			fileclick() {
				$('#q3image').trigger('click')
			},
			Filechange() {
				var _this = this;
				var filePath = $("#q3image").val();
				var file = $("#q3image")[0].files[0];
				console.log(file);
				var fileFormat = filePath
					.substring(filePath.lastIndexOf("."))
					.toLowerCase();
				if (!filePath || filePath.trim() == 0) {
					return;
				}
				// 检查是否是图片
				if (!fileFormat.match(/.png|.jpg|.jpeg/)) {
					// App.oTool.warningT(this.$t('allpage.wrongfile'));
					_this.$refs['Messwarn'].SendMessage(this.$t('allpage.wrongfile'))
					return;
				} else if (file.size > 1024 * 1024 * 2) {
					// App.oTool.warningT(this.$t('allpage.filesizeeror'));
					_this.$refs['Messwarn'].SendMessage(this.$t('allpage.filesizeeror'))
					return;
				}
				let data = new FormData();
				data.append("token", _this.$store.state.token);
				data.append("file", file);
				data.append("type", 'employerimage');
				data.append("language", localStorage.getItem('lang'));
				https.fetchLoginPost(apiUrl.uploadPic, data).then(data => {
						if (Object.is(data.qmiscode, 1000)) {
							_this.khsm1Form.q3_image = data.picname.trim();
							_this.dialogImageUrl = data.picurl.trim();
						} else if (data.qmiscode == 1001) {
							_this.$refs['Messwarn'].SendMessage(data.qmismsg)
						} else if (data.qmiscode == 4001) {
							_this.$refs['Messwarn'].SendMessage(data.qmismsg)
						} else if (Object.is(data.qmiscode, 3000) || Object.is(data.qmiscode, 2000)) {
							_this.$refs['Messwarn'].SendMessage(data.qmismsg)
							setTimeout(() => {
								location.href = this.$store.state.urlapi
							}, 1500);
						}
					})
					.catch(function() {
						// App.oTool.warningT(_this.$t('allpage.pleasechecknet'));
						_this.$refs['Messwarn'].SendMessage(this.$t('allpage.pleasechecknet'))
					});
			},
			eightClick(val){
				if (val == 1 && !this.pdfviewBol.form4) {
					this.khsm1Form.checked = false
				}
			},
			agree(val) {
				console.log(this.khsm1Form.question8 == 0);
				if (this.khsm1Form.question8 == 0) {
					if (!this.pdfviewBol.form1 || !this.pdfviewBol.form2 || !this.pdfviewBol.form3 || 
						!this.pdfviewBol.form5 || !this.pdfviewBol.form6 ) {
						// App.oTool.warningT(this.$t('khsm.qydplease'));
						this.$refs['Messwarn'].SendMessage(this.$t('khsm.qydplease'))
						this.khsm1Form.checked = false;
						
					}
					if(this.khsm1Form.checked){
						this.firstnum++;
						this.wjFlag = false;
					}
					
				}else{

					if (!this.pdfviewBol.form1 || !this.pdfviewBol.form2 || !this.pdfviewBol.form3 || !this.pdfviewBol.form4 ||
						!this.pdfviewBol.form5 || !this.pdfviewBol.form6 ) {
						// App.oTool.warningT(this.$t('khsm.qydplease'));
						this.$refs['Messwarn'].SendMessage(this.$t('khsm.qydplease'))
						this.khsm1Form.checked = false;
					}
					if(this.khsm1Form.checked){
						this.firstnum++;
						this.wjFlag = false;
					}
				}
			},
			backFn(){
				this.$router.push({ 
                    name: 'finance', 
                    // query:{
                    //     id:this.$route.query.id
                    // }
                });
			}, 
			resetFn(){
				this.$refs.khsm1Form.resetFields();
				this.khsm1Form={
					question1: '',
					question2: '',
					question3: '',
					question4: '',
					question5: '',
					question6: '',
					question7: '',
					question8: '',
					question9: '',
					q1_name: '',
					q1_idnumber: '',
					q1_address: '',
					q2_cause: null,
					q3_username: null,
					q3_relationship: null,
					q3_username1: null,
					q3_relationship1: null,
					q4_username: null,
					q4_relationship: null,
					q5_accountnum: null,
					q5_accountname: null,
					q5_contact: null,
					q6_accountnum: null,
					q6_accountname: null,
					q7_accountnum: null,
					q7_accountname: null,
					q7_contact: null,
					q9_username: null,
					q9_relationship: null,
					q9_username1: null,
					q9_relationship1: null,
					checked: false,
					check: null
				},
				this.pdfviewBol={
					form1: false,
					form2: false,
					form3: false,
					form4: false,
					form5: false,
					form6: false,
					// form7: false,
				};
				this.signimageArr = [];
				this.picname = '';
			},
			nextFn() {
				if(this.$store.state.sta){
					this.$router.push({
						path: '/main/riskManagement'
					});
					return
				}
				let _this = this;
				_this.firstnum++;
				_this.handitem++;
					// _this.$refs['khsm1Form'].validate((valid) => {
						if (this.khsm1Form.question1 === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question1',"red_color")
							return
						}else{
							if (this.khsm1Form.question1 == 1){
								if(!this.khsm1Form.q1_name){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question1_1',"red_border")
									this.$set(this.obj,'question1',"red_color")
									return
								}
								if(!this.khsm1Form.q1_idnumber){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question1_2',"red_border")
									this.$set(this.obj,'question1',"red_color")
									return
								}
								if(!this.khsm1Form.q1_address){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question1_3',"red_border")
									this.$set(this.obj,'question1',"red_color")
									return
								}
							}
						}
						if (this.khsm1Form.question2  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question2',"red_color")
							return
						}else{
							if (this.khsm1Form.question2 == 0){
								if(!this.khsm1Form.q2_cause){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question2_1',"red_border")
									this.$set(this.obj,'question2',"red_color")
									return
								}
							}
						}
						if (this.khsm1Form.question3  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question3',"red_color")
							return
						}else{
							if (this.khsm1Form.question3 == 0){
								if(!this.khsm1Form.q3_username){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question3_1',"red_border")
									this.$set(this.obj,'question3',"red_color")
									return
								}
								if(!this.khsm1Form.q3_relationship){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question3_2',"red_border")
									this.$set(this.obj,'question3',"red_color")
									return
								}
								// if(!this.khsm1Form.q3_username1){
								// 	_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
								// 	this.$set(this.obj,'question3_3',"red_border")
								// 	this.$set(this.obj,'question3',"red_color")
								// 	return
								// }
								if(!this.khsm1Form.q3_relationship1){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question3_4',"red_border")
									this.$set(this.obj,'question3',"red_color")
									return
								}
							}
						}
						if (this.khsm1Form.question4  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question4',"red_color")
							return
						}else{
							if (this.khsm1Form.question4 == 0){
								if(!this.khsm1Form.q4_username){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question4_1',"red_border")
									this.$set(this.obj,'question4',"red_color")
									return
								}
								if(!this.khsm1Form.q4_relationship){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question4_2',"red_border")
									this.$set(this.obj,'question4',"red_color")
									return
								}
							}
						}
						if (this.khsm1Form.question5  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question5',"red_color")
							return
						}else{
							if (this.khsm1Form.question5 == 0){
								if(!this.khsm1Form.q5_accountname){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question5_1',"red_border")
									this.$set(this.obj,'question5',"red_color")
									return
								}
								if(!this.khsm1Form.q5_accountnum){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question5_2',"red_border")
									this.$set(this.obj,'question5',"red_color")
									return
								}
							}
						}
						if (this.khsm1Form.question6  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question6',"red_color")
							return
						}else{
							if (this.khsm1Form.question6 == 0){
								if(!this.khsm1Form.q6_accountname){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question6_1',"red_border")
									this.$set(this.obj,'question6',"red_color")
									return
								}
								if(!this.khsm1Form.q6_accountnum){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question6_2',"red_border")
									this.$set(this.obj,'question6',"red_color")
									return
								}
							}
						}
						if (this.khsm1Form.question7  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question7',"red_color")
							return
						}else{
							if (this.khsm1Form.question7 == 0){
								if(!this.khsm1Form.q7_accountname){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question7_1',"red_border")
									this.$set(this.obj,'question7',"red_color")
									return
								}
								if(!this.khsm1Form.q7_contact){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question7_2',"red_border")
									this.$set(this.obj,'question7',"red_color")
									return
								}
								if(!this.khsm1Form.q7_accountnum){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question7_3',"red_border")
									this.$set(this.obj,'question7',"red_color")
									return
								}
							}
						}
						if (this.khsm1Form.question8  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question8',"red_color")
							return
						}
						if (this.khsm1Form.question9  === '') {
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							this.$set(this.obj,'question9',"red_color")
							return
						}else{
							if (this.khsm1Form.question9 == 0){
								if(!this.khsm1Form.q9_username){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question9_1',"red_border")
									this.$set(this.obj,'question9',"red_color")
									return
								}
								if(!this.khsm1Form.q9_relationship){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question9_2',"red_border")
									this.$set(this.obj,'question9',"red_color")
									return
								}
								if(!this.khsm1Form.q9_username1){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question9_3',"red_border")
									this.$set(this.obj,'question9',"red_color")
									return
								}
								if(!this.khsm1Form.q9_relationship1){
									_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
									this.$set(this.obj,'question9_4',"red_border")
									this.$set(this.obj,'question9',"red_color")
									return
								}
							}
						}
						if (!_this.khsm1Form.checked) {
							this.wjFlag = true;
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							return
						}
						debugger
						// 签署判断 and
						// if (!_this.picname) {
						// 	this.signFlag = true;
						// 	_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
						// 	return
						// }
						// 签署判断 end

					// if (valid) {

						if (!_this.khsm1Form.checked) {
							return
						}
						// 签署判断
						// if (_this.khsm1Form.question1===''|| _this.khsm1Form.question2===''|| _this.khsm1Form.question3===''|| _this.khsm1Form.question4===''|| _this.khsm1Form.question5===''|| _this.khsm1Form.question6===''|| _this.khsm1Form.question7===''|| _this.khsm1Form.question8===''|| _this.khsm1Form.question9===''||!_this.picname) {
						if (_this.khsm1Form.question1===''|| _this.khsm1Form.question2===''|| _this.khsm1Form.question3===''|| _this.khsm1Form.question4===''|| _this.khsm1Form.question5===''|| _this.khsm1Form.question6===''|| _this.khsm1Form.question7===''|| _this.khsm1Form.question8===''|| _this.khsm1Form.question9==='') {
							// 签署判断 and
							// if (!_this.picname) {
							// 	this.signFlag = true;
							// }
							// 签署判断 end
							_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
							return
						}
						let json = {
							token: _this.$store.state.token,
						}
						this.fullscreenLoading = true;
						https.fetchLoginPost(apiUrl.newkhsm, {
							// token: json.token,
							// language: localStorage.getItem('lang'),
							// question1: _this.khsm1Form.question1,
							// question2: _this.khsm1Form.question2,
							// question3: _this.khsm1Form.question3,
							// question4: _this.khsm1Form.question4,
							// question5: _this.khsm1Form.question5,
							// question6: _this.khsm1Form.question6,
							// q1Name: _this.khsm1Form.q1_name,
							// q1Idnumber: _this.khsm1Form.q1_idnumber,
							// q1Address: _this.khsm1Form.q1_address,
							// q2Username: _this.khsm1Form.q2_username,
							// q2Relationship: _this.khsm1Form.q2_relationship,
							// q3Organization: _this.khsm1Form.q3_organization,
							// q3Image: _this.khsm1Form.q3_image,
							// q4Cause: _this.khsm1Form.q4_cause,
							// q5Accountnum: _this.khsm1Form.q5_accountnum,
							// q5Accountname: _this.khsm1Form.q5_accountname,
							// q5Contact: _this.khsm1Form.q5_contact,
							// qianmingpic:_this.picname


							token: json.token,
							language: localStorage.getItem('lang'),
							question1:_this.khsm1Form.question1,
							q1_name:_this.khsm1Form.q1_name,
							q1_idnumber:_this.khsm1Form.q1_idnumber,
							q1_address:_this.khsm1Form.q1_address,
							question2:_this.khsm1Form.question2,
							q2_details:_this.khsm1Form.q2_cause,
							question3:_this.khsm1Form.question3,
							q3_organization:_this.khsm1Form.q3_username,
							q3_position:_this.khsm1Form.q3_relationship,
							q3_personal_csrcnum:_this.khsm1Form.q3_username1,
							q3_company_csrcnum:_this.khsm1Form.q3_relationship1,
							question4:_this.khsm1Form.question4,
							q4_name:_this.khsm1Form.q4_username,
							q4_contact:_this.khsm1Form.q4_relationship,
							question5:_this.khsm1Form.question5,
							q5_name:_this.khsm1Form.q5_accountname,
							q5_accountnum:_this.khsm1Form.q5_accountnum,
							question6:_this.khsm1Form.question6,
							q6_name:_this.khsm1Form.q6_accountname,
							q6_accountnum:_this.khsm1Form.q6_accountnum,
							question7:_this.khsm1Form.question7,
							q7_accountname:_this.khsm1Form.q7_accountnum,
							q7_accounttype:_this.khsm1Form.q7_accountname,
							q7_accountnum:_this.khsm1Form.q7_contact,
							question8:_this.khsm1Form.question8,
							question9:_this.khsm1Form.question9,
							q9_name:_this.khsm1Form.q9_username,
							q9_idnumber:_this.khsm1Form.q9_relationship,
							q9_contact:_this.khsm1Form.q9_username1,
							q9_phonenum:_this.khsm1Form.q9_relationship1,
							qianmingpic:_this.picname,

							// token     登錄唯一標識
							// question1  問題1 (0 是 1 否)
							// q1_name  問題1 最終收益持有人名称（选择否必填）
							// q1_idnumber  問題1 身份證/護照號碼（选择否必填）
							// q1_address  問題1 通讯地址（选择否必填）
							// question2 問題2 (0 是 1 否)
							// q2_details 問題2 詳情（选择是必填）
							// question3  問題3  (0 是 1 否)
							// q3_organization 問題3 機構名稱（选择是必填）
							// q3_position  問題3  職稱 （选择是必填）
							// q3_personal_csrcnum  問題3 證監會中央編號 （选择是必填）
							// q3_company_csrcnum 問題3聘任公司證監會中央編號 （选择是必填）
							// question4  問題4 (0 是 1 否)
							// q4_name 問題4 董事或僱員名稱（选择是必填）
							// q4_contact 問題4 關係（选择是必填）
							// question5 問題5 (0 是 1 否)
							// q5_name 問題5 配偶名稱 （选择是必填）
							// q5_accountnum 問題5 賬戶號碼（选择是必填）
							// question6 問題6 (0 是 1 否)
							// q6_name 問題6 配偶名稱 （选择是必填）
							// q6_accountnum 問題6 賬戶號碼（选择是必填）
							// question7 問題7 (0 是 1 否)
							// q7_accountname 問題7 账户名稱（选择是必填）
							// q7_accounttype 問題7 賬戶類別（选择是必填）
							// q7_accountnum 問題7 賬戶號碼（选择是必填）
							// question8 問題8 (0 是 1 否)
							// qianmingpic 签名图片名称								

						}).then((data) => {
							if (Object.is(data.qmiscode, 1000)) {
								this.fullscreenLoading = false;
								_this.$router.push({
									path: '/main/riskManagement'
								});
							} else if (Object.is(data.qmiscode, 3000)) {
								_this.$refs['Messwarn'].SendMessage(data.qmismsg)
								setTimeout(() => {
									location.href = this.$store.state.urlapi
								}, 1500);
							} else if (Object.is(data.qmiscode, 2000)) {
								setTimeout(() => {
									location.href = this.$store.state.urlapi
								}, 1500);
							}else {
								_this.$refs['Messwarn'].SendMessage(data.qmismsg)
							}
						}).catch(err => {
							console.log(err);
						});
					// } else {
					// 	for (let a = 1; a < 7; a++) {
					// 		this.$set(_this.obj,['question' + a],(_this.khsm1Form['question' + a] === 0 || _this.khsm1Form['question' + a] ===
					// 			1) ? "" : "red_color")
					// 	}
					// 	_this.$refs['Messwarn'].SendMessage(_this.$t('login.khname'))
					// 	// App.oTool.warningT(_this.$t('login.khname'))
					// }
				// });
			},
		},
	};
</script>

<style lang="scss">
	.el-textarea {
		.el-textarea__inner {
			color: #666 !important;
		}

		.el-input__count {
			color: #666 !important;
			font-size: 0.8rem !important;
		}
	}
	.abc .el-form-item__label{
		white-space: nowrap;
	}
</style>
